import { useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, Unsubscribe } from 'firebase/messaging';
import { notify } from '~/utils/helper';
import authApi from '~/apis/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FCM_API_KEY,
  authDomain: process.env.REACT_APP_FCM_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FCM_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FCM_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FCM_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FCM_APP_ID,
  measurementId: process.env.REACT_APP_FCM_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export default function usePushNotifications() {
  useEffect(() => {
    let unsubscribe: Unsubscribe;
    (async () => {
      // Step 1: Request get Token
      const token = await requestSubscription();
      if (!token) return;

      // Step 2: Send token to Server
      const result = await sendSubscriptionToPushServer(token);
      if (!result) return;
    })();
    // Step 3: Listen subscription
    unsubscribe = onMessage(messaging, (response) => {
      // const fakeResponseNotification = {
      //   from: '654926575320',
      //   messageId: 'd7563ed8-9e50-4453-b284-2deb6394b5e7',
      //   notification: {
      //     title: 'Cảnh báo cháy',
      //     body: '',
      //   },
      //   data: {
      //     type: 'fire_alarm',
      //     location_name: '123 CG',
      //     location_address: '123 Cầu giấy',
      //     sensor_location: 'Ban công',
      //     sensor_type: 17,
      //     id: '6927d41e571b025343d7c333',
      //   },
      // };

      const payload = response;
      const notification = payload.notification;
      const data = payload.data;

      const isFireAlarm = payload.data?.type === 'fire_alarm';
      const type = isFireAlarm ? 'fire_alarm' : 'info';
      const body = notification?.title ?? '';
      notify(type, body, data);
    });
    return () => {
      if (unsubscribe) unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const requestSubscription = async () => {
    let currentToken;
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        currentToken = await getToken(messaging, {
          vapidKey: process.env.REACT_APP_FCM_PUBLIC_KEY,
        });
      }
    } catch (e) {
      console.error(e);
    }

    if (!currentToken) notify('error', 'Vui lòng cho phép nhận thông báo');

    return currentToken;
  };

  const sendSubscriptionToPushServer = async (token: string) => {
    try {
      const response = await authApi.updateFcmToken({ fcm_token: token });
      return response;
    } catch (error) {
      notify('error', 'Error');
      return false;
    }
  };

  return {};
}
